import { parse } from "@config/theme";
import { css } from "linaria";
import React, { FC } from "react";
type HeroIndicatorsProps = {
  length: number;
  activeIndex: number;
  shouldAnimate: boolean;
};
export const HeroIndicators: FC<HeroIndicatorsProps> = ({
  length,
  activeIndex,
  shouldAnimate
}) => {
  const items = [];
  for (let i = 0; i < length; i++) {
    items.push(<div key={i} className={indicator} data-active={i === activeIndex && shouldAnimate ? "" : undefined} />);
  }
  return <div className={container}>{items}</div>;
};
const container = parse({
  position: "absolute",
  display: "grid",
  width: "100%"
}, "c13vjts6");
const indicator = parse({
  position: "relative"
}, "i1k5umg0");

require("./HeroIndicators.linaria.module.css!=!../../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./HeroIndicators.tsx");